<template>
  <interview-layout :touch-and-validate="touchAndValidate" :show-help-button="true">
    <!-- inner wrapper used for centering -->
    <div class="">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest max-100">Eigendomsinformatie</h1>
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card inner-class="container-meager w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">

            <!-- inputs -->
            <base-input
              type="radiobuttons" :options="yesNo"
              name="PropertyOwner"
              v-model:value="lead.ownership.PropertyOwner" :validator="v$.ownership.PropertyOwner" :do-not-reward="true">
              Bent u de eigenaar van de woning?
            </base-input>

            <Transition name="fade-in-up">
              <base-input
                v-show="lead.ownership.PropertyOwner == false"
                type="radiobuttons" :options="yesNo" name="OwnerPermission"
                v-model:value="lead.ownership.OwnerPermission" :validator="v$.ownership.OwnerPermission" :do-not-reward="true">
                Heeft u toestemming van de eigenaar?
              </base-input>
            </Transition>

            <Transition name="fade-in-up">
              <base-input
                v-show="showOwnerIsResident"
                type="radiobuttons" :options="yesNo"
                name="OwnerIsResident"
                v-model:value="lead.ownership.OwnerIsResident"
                :validator="v$.ownership.OwnerIsResident"
                :do-not-reward="true">
                Bent u ook de bewoner van de woning?
              </base-input>
            </Transition>
            
            <base-input
              v-show="!isD2DLead"
              type="radiobuttons" :options="yesNo"
              name="HoaMember"
              v-model:value="lead.ownership.HoaMember" :validator="v$.ownership.HoaMember" :do-not-reward="true">
              Bent u onderdeel van een VVE?
            </base-input>

            <Transition name="fade-in-up">
              <base-input
                v-show="lead.ownership.HoaMember == true"
                type="radiobuttons" :options="yesNo" name="HoaPermission"
                v-model:value="lead.ownership.HoaPermission" :validator="v$.ownership.HoaPermission" :do-not-reward="true">
                Heeft u toestemming van de VVE?
              </base-input>
            </Transition>
          </base-form>
        <!-- form card end -->
        </base-card>

        <!-- form 2 Owner contact card -->
        <Transition name="fade-in-up">
          <base-card class="pt-2" inner-class="container-meager fade-in-up-enter-active animation-slowest" color="alternate" :outer-padding="true" v-show="showContactForm">
            <base-form @submit="onSubmit">
              <div class="section-owner-contact pt-3">
                <h5 v-if="lead.ownership.PropertyOwner === false && lead.ownership.OwnerPermission === true">
                  Contactgegevens eigenaar woning
                </h5>
                <h5 v-else-if="lead.ownership.HoaMember === true && lead.ownership.HoaPermission === true">
                  Contactgegevens vertegenwoordiger VVE
                </h5>

                <!-- Eigenaar -->
                <template v-if="lead.ownership.PropertyOwner === false && lead.ownership.OwnerPermission === true">
                  <base-input name="OwnerName"
                    v-model:value="lead.ownership.OwnerName"
                    :validator="v$.ownership.OwnerName">
                    Volledige naam eigenaar
                  </base-input>
                  <base-input name="OwnerPhone" placeholder="+316 00 00 00 00"
                    v-model:value="lead.ownership.OwnerPhone"
                    type="phone"
                    :validator="v$.ownership.OwnerPhone">
                    Telefoonnummer eigenaar
                  </base-input>
                  <base-input name="OwnerEmail" placeholder="test@example.com"
                    v-model:value="lead.ownership.OwnerEmail"
                    :validator="v$.ownership.OwnerEmail"
                    :debounce="700"
                    :debounce-touch-only="true">
                    E-mailadres eigenaar
                  </base-input>
                </template>

                <!-- VVE -->
                <template v-else-if="lead.ownership.HoaMember === true && lead.ownership.HoaPermission === true">
                  <base-input name="HoaRepName"
                    v-model:value="lead.ownership.HoaRepName"
                    :validator="v$.ownership.HoaRepName">
                    Volledige naam
                  </base-input>
                  <base-input name="HoaRepPhone" placeholder="+316 00 00 00 00"
                    v-model:value="lead.ownership.HoaRepPhone"
                    type="phone"
                    :validator="v$.ownership.HoaRepPhone">
                    Telefoonnummer
                  </base-input>
                  <base-input name="HoaRepEmail" placeholder="test@example.com"
                    v-model:value="lead.ownership.HoaRepEmail"
                    :validator="v$.ownership.HoaRepEmail"
                    :debounce="700"
                    :debounce-touch-only="true">
                    E-mailadres
                  </base-input>
                </template>
              </div>
            </base-form>
          </base-card>
        </Transition>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.ownership.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
  import { MunicipalitySubsidyService } from '@/services/MunicipalitySubsidyService';

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ]
      };
    },
    computed: {
      isD2DLead() {
        return this.lead.meta.LeadSource?.includes('d2d.bureauverduurzamen.nl');
      },
      showContactForm() {
        if (this.lead.ownership.PropertyOwner === false && this.lead.ownership.OwnerPermission === true) {
          return true;
        } else if (this.lead.ownership.HoaMember === true && this.lead.ownership.HoaPermission === true) {
          return true;
        }

        return false;
      },
      showOwnerIsResident() {
        if (this.lead.ownership.PropertyOwner !== true) {
          return false;
        }
        
        const subsidies = MunicipalitySubsidyService.getEligibleSubsidies(this.lead, 'address');
        if (subsidies.length === 0) {
          return false;
        }

        return true
      },
      // contactLabels() {
      //   if (this.lead.ownership.PropertyOwner === false && this.lead.ownership.OwnerPermission === true) {
      //        return {
      //           title: 'Contactgegevens eigenaar woning',
      //           nameField: 'OwnerName',
      //           nameLabel: 'Volledige naam eigenaar',
      //           phoneField: 'OwnerPhone',
      //           phoneLabel: 'Telefoonnummer eigenaar',
      //           emailField: 'OwnerEmail',
      //           emailLabel: 'E-mailadres eigenaar'
      //         };
      //   } else if (this.lead.ownership.HoaMember === true && this.lead.ownership.HoaPermission === true) {
      //       return {
      //         title: 'Contactgegevens vertegenwoordiger VVE',
      //         nameField: 'HoaRepName',
      //         nameLabel: 'Volledige naam',
      //         phoneField: 'HoaRepPhone',
      //         phoneLabel: 'Telefoonnummer',
      //         emailField: 'HoaRepEmail',
      //         emailLabel: 'E-mailadres'
      //       };
      //   } else {
      //     return {
      //         title: 'Contactgegevens',
      //         nameLabel: 'Volledige naam',
      //         phoneLabel: 'Telefoonnummer',
      //         emailLabel: 'E-mailadres'
      //     };
      //   }
      // },
    },
    methods: {
      touchAndValidate() {
        this.v$.ownership.$touch();
        return !this.v$.ownership.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    }
  }
</script>

<style lang="scss">
</style>